/* eslint-disable no-case-declarations */
import { useReducer } from 'react';
import { useEffect } from 'react';
import { parseQueryParams } from 'util/query-params-util';
import {
  getModalActionKey,
  getModalRouteActionValue,
  RouteAction,
  parseActionRouteParams
} from './util';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';

type Action = { type: 'NOTIFY_ROUTE_ACTION_MODAL_LISTENER'; payload: string };
type UseRouteActionState = {
  action: string | null;
  type: string | null;
};
type UseRouteActionCallback = (args: UseRouteActionState & { params: any }) => any;

const useRouteAction = (callback: UseRouteActionCallback): void => {
  const [modalState] = useModal();
  const { action: routeAction } = parseQueryParams(window.location.search) || {};

  /** using dispatch here to have current ref of 'callback' */
  const reducer = (state: UseRouteActionState, action: Action): UseRouteActionState => {
    switch (action.type) {
      case 'NOTIFY_ROUTE_ACTION_MODAL_LISTENER':
        const payload = {
          action: getModalRouteActionValue(action.payload),
          type: RouteAction.MODAL_TYPE,
          params: parseActionRouteParams(window.location.search)
        };

        callback && callback(payload);
        return payload;
      default:
        return { action: null, type: null };
    }
  };
  const [state, dispatch] = useReducer<React.Reducer<UseRouteActionState, Action>>(reducer, {
    action: null,
    type: null
  });

  useEffect(() => {
    if (routeAction && state.action !== routeAction) {
      if (
        routeAction.includes(getModalActionKey()) &&
        !modalState.isOpen &&
        !modalState.isRouteActionChanging
      ) {
        dispatch({
          type: 'NOTIFY_ROUTE_ACTION_MODAL_LISTENER',
          payload: Array.isArray(routeAction) ? routeAction.join(',') : routeAction
        });
      }
      /**
       * ...more potential non-modal actions here...
       */
    }
  }, [routeAction, modalState.isOpen, modalState.isRouteActionChanging, state.action]);
};

export default useRouteAction;
